import { __decorate } from "tslib";
import { property } from 'lit-element';
export const ProgressMixin = (base) => {
    class Progress extends base {
        constructor() {
            super(...arguments);
            /**
             * Minimum bound of the progress bar.
             */
            this.min = 0;
            /**
             * Maximum bound of the progress bar.
             */
            this.max = 1;
            /**
             * Indeterminate state of the progress bar.
             * This property takes precedence over other state properties (min, max, value).
             */
            this.indeterminate = false;
        }
        firstUpdated(props) {
            super.firstUpdated(props);
            this.setAttribute('role', 'progressbar');
        }
        updated(props) {
            super.updated(props);
            const minChanged = props.has('min');
            if (minChanged) {
                this._minChanged(this.min);
            }
            const maxChanged = props.has('max');
            if (maxChanged) {
                this._maxChanged(this.max);
            }
            const valueChanged = props.has('value');
            if (valueChanged) {
                this._valueChanged(this.value);
            }
            if (valueChanged || minChanged || maxChanged) {
                this._normalizedValueChanged(this.value, this.min, this.max);
            }
        }
        _normalizedValueChanged(value, min, max) {
            const newValue = this._normalizeValue(value, min, max);
            this.style.setProperty('--vaadin-progress-value', String(newValue));
        }
        _valueChanged(value) {
            this.setAttribute('aria-valuenow', String(value));
        }
        _minChanged(min) {
            this.setAttribute('aria-valuemin', String(min));
        }
        _maxChanged(max) {
            this.setAttribute('aria-valuemax', String(max));
        }
        /**
         * Percent of current progress relative to whole progress bar (max - min)
         */
        _normalizeValue(value, min, max) {
            let nV;
            if (!value && value !== 0) {
                nV = 0;
            }
            else if (min >= max) {
                nV = 1;
            }
            else {
                nV = (value - min) / (max - min);
                nV = Math.min(Math.max(nV, 0), 1);
            }
            return nV;
        }
    }
    __decorate([
        property({ type: Number })
    ], Progress.prototype, "value", void 0);
    __decorate([
        property({ type: Number })
    ], Progress.prototype, "min", void 0);
    __decorate([
        property({ type: Number })
    ], Progress.prototype, "max", void 0);
    __decorate([
        property({ type: Boolean, reflect: true })
    ], Progress.prototype, "indeterminate", void 0);
    return Progress;
};
//# sourceMappingURL=vaadin-progress-mixin.js.map